import { Office } from "@gettactic/api";
import { DEFAULT_TIME_SETTINGS } from "@gettactic/api";
import { camelizeKeys } from "../objects/camelizeKeys";

type ReservationTimeSettings = {
  startHour: number;
  startMinutes: number;
  endHour: number;
  endMinutes: number;
  deskDuration: number;
  meetingRoomDuration: number;
}
export const getDefaultsHoursFromOffice = (
  office: Office | null
): ReservationTimeSettings => {
  if (!office) {
    return camelizeKeys(DEFAULT_TIME_SETTINGS) as ReservationTimeSettings;
  }
  return camelizeKeys(office.settings?.reservation_default_time || DEFAULT_TIME_SETTINGS) as ReservationTimeSettings;
};
